export default function StatusCard({ title, status, color }) {
  return (
    <div className="card">
      <h3>{title}</h3>
      <div className={`status ${color}`}>{status}</div>
    </div>
  );
}